// Seren web (approved amendment): public pages are the provided static HTML (SEO/OG without JS);
// authenticated surfaces (member/dashboard/admin) are the provided HTML bound live via /js/*-wire.js.
// The React shell intentionally mounts nothing — no CSS import may touch the pixel-spec pages.
const rootEl = document.getElementById("root");
if (rootEl) {
  // reserved for future React-hosted surfaces
}
export {};
